import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import "bootstrap/dist/css/bootstrap.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  DATE_RANGE,
  SOP_LEVEL_LOGS_DROPDOWN,
  SOP_LOGS_DATE_FILTER,
  STUDY_LEVEL_LOGS_DROPDOWN,
  STUDY_LOGS_DATE_FILTER,
} from "../../DropdownConstants";
import "../../components/Headers/Header.css";
import "../Headers/Header.css";
import HomeHeader from "../HomeHeader";
import "../HomeHeader.css";
import "../Modal/Modal.css";
import SideBar from "../SideBar/SideBar";
import SopLevelTable from "../Tables/SopLevelTable";
import StudyLevelTable from "../Tables/StudyLevelTable";

const Home = () => {
  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState({
    asc: true,
    sort_by: "",
    keyword: "",
    date_field: "",
    date_filter: "",
    local_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
  const [sortby, setsortby] = useState("");
  const [flagforfilterby, setflagforfilterby] = useState(false);
  const [customDateFlag, setCustomDateFlag] = useState(false);
  const [dateFilter, setDateFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(null);
  const [dateField, SetDateField] = useState("");
  const [sopData, setSopData] = useState(false);
  const [searchflag, setsearchflag] = useState(false);
  const [asc, setAsc] = useState(true);
  const [searchWord, setSearchWord] = useState("");

  // useEffect(() => {
  //   handleSort();
  // }, [sortby]);

  useEffect(() => {
    const isAuthenticated = localStorage.getItem("authenticated");
    if (isAuthenticated != "true") {
      navigate("/login");
    }
  }, []);

  const handleFilterByDate = (option) => {
    if (option === "") {
      setflagforfilterby(false);
      setDateFilter(option);
      setCustomDateFlag(false);
    }
    if (option !== "Custom_Date" && option !== "") {
      setEndDate(null);
      const filterobj = {
        asc: asc,
        sort_by: sortby,
        keyword: searchWord,
        date_field: dateField,
        date_filter: option,
        local_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      setDateFilter(option);
      setSearchInput(filterobj);
      setflagforfilterby(true);
      setCustomDateFlag(false);
    }
    if (option === "Custom_Date") {
      setDateFilter("Custom_Date");
      setflagforfilterby(false);
      setCustomDateFlag(true);
    }
  };

  const handleStartDateChange = (e) => {
    const value = e.target.value;
    setStartDate(value);
  };

  const handleEndDateChange = (e) => {
    let value = e.target.value;
    if (startDate && value && startDate <= value) {
      const filterobj = {
        asc: asc,
        sort_by: sortby,
        keyword: searchWord,
        date_field: dateField,
        date_filter: [startDate, value],
        local_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      setEndDate(value);
      setSearchInput(filterobj);
      setflagforfilterby(true);
      // setDateFilter([startDate, value]);
    } else {
      setEndDate(null);
      setflagforfilterby(false);
    }
  };

  const handleSearch = (e) => {
    const filterobj = {
      asc: asc,
      sort_by: sortby,
      keyword: e.target.value,
      date_field: dateField,
      date_filter:
        dateFilter == "Custom_Date" ? [startDate, endDate] : dateFilter,
      local_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    setSearchWord(e.target.value);
    setSearchInput(filterobj);
    setsearchflag(true);
  };

  const handleSort = (value) => {
    setsearchflag(false);

    const filterobj = {
      asc: asc,
      sort_by: value,
      keyword: searchWord,
      date_field: dateField,
      date_filter:
        dateFilter == "Custom_Date" ? [startDate, endDate] : dateFilter,
      local_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    setsortby(value);
    setSearchInput(filterobj);
  };
  const handleDateField = (value) => {
    SetDateField(value);
    if (value === "") {
      setCustomDateFlag(false);
      setDateFilter("");
    }

    if (value !== "" && dateFilter) {
      const filterobj = {
        asc: asc,
        sort_by: sortby,
        keyword: searchWord,
        date_field: value,
        date_filter: dateFilter,
        local_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      setSearchInput(filterobj);
    }
    if (value !== "" && dateFilter && endDate) {
      const filterobj = {
        asc: asc,
        sort_by: sortby,
        keyword: searchWord,
        date_field: value,
        date_filter: [startDate, endDate],
        local_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      setSearchInput(filterobj);
    }
  };
  // const handleDateFilter = (e) => {
  //   const filterobj = {
  //     asc: asc,
  //     sort_by: sortby,
  //     keyword: searchWord,
  //     date_field: e.target.value,
  //     date_filter: dateFilter,
  //     local_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  //   };
  //   SetDateField(e.target.value);
  //   setSearchInput(filterobj);
  //   setsearchflag(true);
  // };

  const handleOrder = () => {
    setsearchflag(false);
    if (sortby !== "") {
      const filterobj = {
        asc: !asc,
        sort_by: sortby,
        keyword: searchWord,
        date_field: dateField,
        date_filter:
          dateFilter == "Custom_Date" ? [startDate, endDate] : dateFilter,
        local_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      setSearchInput(filterobj);
      setAsc((asc) => !asc);
    }
  };

  const styles = {
    btn_styles: {
      height: 39,
      width: 200,
      color: "black",
      backgroundColor: "#0FC4A0",
      position: "relative",
      top: 25,
      fontWeight: "bold",
      cursor: "pointer",
      fontFamily: "Montserrat",
    },
  };

  const hadlestudylevelsearch = () => {
    setSopData(false);
    setsortby("");
    handleSort("");
    setSearchInput({
      asc: true,
      sort_by: "",
      keyword: "",
      date_field: "",
      date_filter: "",
      local_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
  };

  const hadlesoplevelsearch = () => {
    setSopData(true);
    setsortby("");
    handleSort("");
    setSearchInput({
      asc: true,
      sort_by: "",
      keyword: "",
      date_field: "",
      date_filter: "",
      local_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
  };

  return (
    <div className="d-flex min-vh-100  background">
      <SideBar />
      <div>
        <HomeHeader />

        <div className="header-home">
          <div className="header-text">
            {!sopData ? "STUDY LEVEL LOGS" : "SOP LEVEL LOGS"}
          </div>

          {/* <div className="widget ">
            <button
              onClick={() => {
                navigate("/widget-page");
                setTimeout(() => {
                  navigate("/home");
                }, 100);
              }}
              className="btn btn-widget"
            >
              Open Widget
            </button>
          </div> */}

          <div className="d-flex justify-content-between mb-5">
            <div className="d-flex justify-content-start gap-3">
              <div>
                <h6
                  style={{
                    fontFamily: "Montserrat",
                    color: "#0fc4a0",
                    fontSize: "14px",
                  }}
                >
                  Sort by
                  <span style={{ color: "black" }}>&nbsp;||&nbsp;</span>
                  <span
                    style={{ color: "rgb(249, 215, 161)", cursor: "pointer" }}
                  >
                    <span
                      onClick={handleOrder}
                      style={{ fontFamily: "Montserrat" }}
                    >
                      {asc ? "Desc" : "Asc"}
                    </span>
                    {asc ? (
                      <i className="fa fa-sort-amount-asc"></i>
                    ) : (
                      <i className="fa fa-sort-amount-desc"></i>
                    )}
                  </span>
                </h6>

                <Select
                  displayEmpty
                  value={sortby || ""}
                  placeholder="Sort by"
                  className="sort"
                  name="Sort"
                  onChange={(e) => {
                    handleSort(e.target.value);
                  }}
                  style={{ color: "white", height: "39px", width: "10rem" }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        backgroundColor: "#121c1b",
                        color: "white",
                        borderRadius: "5px",
                        border: "1px solid #0fc4a0",
                      },
                    },
                  }}
                >
                  <MenuItem value="" style={{ fontSize: "14px" }}>
                    Select
                  </MenuItem>
                  {!sopData &&
                    STUDY_LEVEL_LOGS_DROPDOWN.map((option) => (
                      <MenuItem
                        key={option.label}
                        value={option.value}
                        style={{ fontSize: "14px" }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  {sopData &&
                    SOP_LEVEL_LOGS_DROPDOWN.map((option) => (
                      <MenuItem
                        key={option.label}
                        value={option.value}
                        style={{ fontSize: "14px" }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                </Select>
              </div>

              <div className="mr-4 d-flex flex-column justify-content-between">
                <h6
                  style={{
                    fontFamily: "Montserrat",
                    color: "#0fc4a0",
                    fontSize: "14px",
                  }}
                >
                  Search
                </h6>
                <i className="icon_box_valid neural_net_active"></i>
                <input
                  style={{ height: "39px", width: "10rem" }}
                  type="search"
                  placeholder="Search here"
                  className="search"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearch(e);
                    }
                  }}
                />
              </div>
              <div>
                <h6
                  style={{
                    fontFamily: "Montserrat",
                    color: "#0fc4a0",
                    fontSize: "14px",
                  }}
                >
                  Filter By Date
                </h6>

                <Select
                  displayEmpty
                  value={dateField || ""}
                  placeholder="date filter"
                  className="sort"
                  name="Sort"
                  onChange={(e) => {
                    handleDateField(e.target.value);
                  }}
                  style={{ color: "white", height: "39px", width: "10rem" }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        backgroundColor: "#121c1b",
                        color: "white",
                        borderRadius: "5px",
                        border: "1px solid #0fc4a0",
                      },
                    },
                  }}
                >
                  <MenuItem value="" style={{ fontSize: "14px" }}>
                    Select
                  </MenuItem>
                  {!sopData &&
                    STUDY_LOGS_DATE_FILTER.map((option) => (
                      <MenuItem
                        key={option.label}
                        value={option.value}
                        style={{ fontSize: "14px" }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  {sopData &&
                    SOP_LOGS_DATE_FILTER.map((option) => (
                      <MenuItem
                        key={option.label}
                        value={option.value}
                        style={{ fontSize: "14px" }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                </Select>
              </div>
              {dateField ? (
                <div>
                  <h6
                    style={{
                      fontFamily: "Montserrat",
                      color: "#0fc4a0",
                      fontSize: "14px",
                    }}
                  >
                    Filter By
                  </h6>

                  <Select
                    displayEmpty
                    value={dateFilter || ""}
                    placeholder="date filter"
                    className="sort"
                    name="Sort"
                    onChange={(e) => {
                      handleFilterByDate(e.target.value);
                    }}
                    style={{ color: "white", height: "39px", width: "10rem" }}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          backgroundColor: "#121c1b",
                          color: "white",
                          borderRadius: "5px",
                          border: "1px solid #0fc4a0",
                        },
                      },
                    }}
                  >
                    <MenuItem value="" style={{ fontSize: "14px" }}>
                      Select
                    </MenuItem>
                    {!sopData &&
                      DATE_RANGE.map((option) => (
                        <MenuItem
                          key={option.label}
                          value={option.value}
                          style={{ fontSize: "14px" }}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    {sopData &&
                      DATE_RANGE.map((option) => (
                        <MenuItem
                          key={option.label}
                          value={option.value}
                          style={{ fontSize: "14px" }}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                  </Select>
                </div>
              ) : (
                <></>
              )}
            </div>
            {customDateFlag && (
              <>
                <div>
                  <h6
                    style={{
                      fontFamily: "Montserrat",
                      color: "#0fc4a0",
                      fontSize: "14px",
                    }}
                  >
                    Start Date
                  </h6>
                  <input
                    type="date"
                    placeholder="Enter start Date"
                    className="dateclass"
                    style={{ height: "39px", width: "10rem" }}
                    value={startDate}
                    onChange={handleStartDateChange}
                    required
                  />
                </div>
                <div>
                  <h6
                    style={{
                      fontFamily: "Montserrat",
                      color: "#0fc4a0",
                      fontSize: "14px",
                    }}
                  >
                    End Date
                  </h6>
                  <input
                    type="date"
                    className="dateclass"
                    style={{ height: "39px", width: "10rem" }}
                    onChange={handleEndDateChange}
                    value={endDate !== null ? endDate : ""}
                    required
                  />
                </div>
              </>
            )}

            {sopData && (
              <button
                type="button"
                className="btn  mr-4 shadow  btn-dataset"
                style={styles.btn_styles}
                onClick={hadlestudylevelsearch}
              >
                Study Level Logs
              </button>
            )}
            {!sopData && (
              <button
                type="button"
                className="btn  mr-4 shadow  btn-dataset"
                style={styles.btn_styles}
                onClick={hadlesoplevelsearch}
              >
                SOP Level Logs
              </button>
            )}
          </div>
        </div>

        <div
          style={{
            marginLeft: "6.2rem ",
          }}
        >
          {!sopData && (
            <StudyLevelTable
              searchInput={searchInput}
              flagforfilterby={flagforfilterby}
              searchflag={searchflag}
              setsearchflag={setsearchflag}
              setflagforfilterby={setflagforfilterby}
            />
          )}
        </div>
        <div>
          {sopData && (
            <SopLevelTable
              searchInput={searchInput}
              flagforfilterby={flagforfilterby}
              searchflag={searchflag}
              setsearchflag={setsearchflag}
              setflagforfilterby={setflagforfilterby}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
